/**
 * External dependencies
 */
import React from 'react';
import { Box, Heading, Stack } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/dashboard/settings/navigation';

/**
 * Style dependencies
 */
import './styles.scss';

const SettingsComponent = (props) => {
    return <Main>
        <Stack space="large">
            <Navigation section="general"/>
            <Heading level='1'>General Settings</Heading>
        </Stack>
    </Main>
}

export default SettingsComponent;
    